import { ReactComponent as FullPrimary } from '@assets/logo/service_logo_full_primary.svg';
import { ReactComponent as FullWhite } from '@assets/logo/service_logo_full_white.svg';
import { ReactComponent as SinglePrimary } from '@assets/logo/service_logo_single_primary.svg';
import { ReactComponent as SingleWhite } from '@assets/logo/service_logo_single_white.svg';
import { ReactComponent as MiniPrimary } from '@assets/logo/service_logo_mini_primary.svg';
import { ReactComponent as MiniWhite } from '@assets/logo/service_logo_mini_white.svg';

import { LogoProps } from './Logo.types';

export default function Logo({
  variant = 'single',
  color = 'primary',
}: LogoProps) {
  // const logo = () => {
  switch (variant) {
    case 'single': {
      return color === 'primary' ? (
        <SinglePrimary data-testid="SinglePrimary" />
      ) : (
        <SingleWhite data-testid="SingleWhite" />
      );
    }
    case 'full': {
      return color === 'primary' ? (
        <FullPrimary data-testid="FullPrimary" />
      ) : (
        <FullWhite data-testid="FullWhite" />
      );
    }
    case 'mini': {
      return color === 'primary' ? (
        <MiniPrimary data-testid="MiniPrimary" />
      ) : (
        <MiniWhite data-testid="MiniWhite" />
      );
    }
  }
}
